import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import Table from "./addTemplate";
import AddTemplate from "./CreateTemplate";
// import UpdateTemplate from "../../pages/CreateTemplate";
// import CapCourseTable from "../capCourseManagement/capCourseTable";

export default function Index() {
  const naviagte = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

  // const [course, setCourse] = useState("courselist");

  // useEffect(() => {
  //   setCourse(page);
  // }, [page]);

  return (
    <Grid
      p={page === "templatelist" ? "none" : 3}
      sx={{
        minHeight: "50vh",
        backgroundColor:
          page === "templatelist" ? "none" : "#fff",
        borderRadius: "8px",
      }}
    >
      {page === "templatelist" && (
        <Grid container>
          <Grid
            item
            md={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <MauvelousPrimaryButton
              title={"Add Template"}
              handleClick={() =>
                naviagte(
                  `/${Cookies.get(
                    "mhet_mst_project"
                  )}/add-template?page=createtemplate`
                )
              }
            />
            <div style={{marginLeft:10}}>
            {/* <MauvelousPrimaryButton
              title={"Add Template"}
              handleClick={() =>
                naviagte(
                  `/${Cookies.get(
                    "mhet_mst_project"
                  )}/add-template`
                )
              }
            /> */}
            </div>
          </Grid>
          <Grid item md={12}>
            <Table />
          </Grid>
        </Grid>
      )}
      {page === "addtemplate" && <Table />}
      {page === "createtemplate" && <AddTemplate />}
      {page === "updatetemplate" && <AddTemplate />}
      {page === "previewtemplate" && <AddTemplate />}
    </Grid>
  );
}
